import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";

interface SuccessMessageProps {
  text: string;
  containerClassName?: string;
}

export default function SuccessMessage(props: SuccessMessageProps) {
  const { t } = useTranslation();

  return (
    <div
      className={
        "container " +
        (props.containerClassName ? props.containerClassName : "")
      }
    >
      <Alert variant="success" className="mt-5">
        {t(props.text)}
      </Alert>
    </div>
  );
}
